import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { DocumentsList } from '../../Documents/components/documentsList';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class VehicleDetailsDocumentsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get documents() {
    return this.props.vehicle?.documents ?? [];
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  render() {
    return (
      <Container>
        <DocumentsList entityId={this.entityId} entityType={this.entityType} items={this.documents}></DocumentsList>
      </Container>
    );
  }
}

VehicleDetailsDocumentsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleDetailsDocuments = compose(
  withConnect,
  withRouter,
)(VehicleDetailsDocumentsComp);
